import {h} from 'preact'
import {PureComponent} from 'preact-compat'

import { ZendeskHit } from '../algolia/components'
import ZendeskResults from './ZendeskResults'

interface Props {
  hits: Array<ZendeskHit>
  pageCount: number,
}

interface State {
  hits: Array<ZendeskHit>,
}

export default class extends PureComponent<Props, State> {
  constructor () {
    super()
    this.state = {
      hits: []
    }
  }

  updateList () {
    let joinWith: State['hits'] = []
    if (this.props.pageCount > 0) {
      joinWith = this.state.hits
    }

    this.setState({
      hits: joinWith.concat(this.props.hits)
    })
  }

  componentDidMount () {
    this.updateList()
  }

  componentDidUpdate (prevProps: Props) {
    if (JSON.stringify(this.props.hits) === JSON.stringify(prevProps.hits)) return

    this.updateList()
  }

  render () {
    return <div> {
      this.state.hits.map(hit => {
        return <ZendeskResults hit={hit} />
      })
    }</div>
  }
}

